export default __webpack_public_path__ + "static/media/demo_2.95e716b2.webm";